import { Injectable } from '@angular/core';
import { EmployeeBusinessService } from 'DBadgeEmployee-app/src/app/core/services/business.service';

@Injectable()
export abstract class ProfileService {
    abstract isCancelBadgeRequestVisible(photoRequestStatusId: number, badgeRequestStatusId: number): boolean;
    abstract isCancelBadgeRequestDisabled(photoRequestStatusId: number, badgeRequestStatusId: number): boolean;
    abstract isCancelBadgeRequestVisibleUSI(photoRequestStatusId: number, badgeRequestStatusId: number): boolean;

    constructor(protected businessService: EmployeeBusinessService) {}
}
